export const SET_FOREIGN_MODE = 'SET_FOREIGN_MODE'